import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useState } from 'react';

import { getAppBarConfig } from '@/components/layout/navbar/navbar.config';
import NavMenuItem from '@/components/layout/navbar/NavMenuItem';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';

import useFeatureFlags from '@/hooks/useFeatureFlags';
import useCustomer from '@/hooks/user/useCustomer';
import { ESCRIPT_REFILL_ROUTE } from '@/routes/route-paths';
import { Box, IconButton } from '@montugroup/design-system';
import Logout from './Logout';
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  StyledAppDrawer,
  StyledListContainer,
  StyledNavContainer,
  StyledNavContainerInner,
} from './Sidebar.styles';
import { StyledSidebarMenuLink } from './SidebarNavMenuItem.styles';

function Sidebar() {
  const { Logo, Icon } = usePortalPartnerBrand();
  const [open, setOpen] = useState<boolean>(true);
  const { flags } = useFeatureFlags();
  const { data: customer } = useCustomer();
  const mainMenuItems = getAppBarConfig({ flags, customer });

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

  return (
    <>
      {/* 
      This CSS variable defines the sidebar width at the :root level, making it globally accessible.
      When the sidebar is toggled between expanded and collapsed states, this variable updates.
      Other components like MobileOnlySticky in OrderMedication.style.tsx use this variable 
      to adjust their positioning (via `left: 'var(--sidebar-width, DRAWER_WIDTH)'`).
    */}
      <style>{`:root { --sidebar-width: ${open ? DRAWER_WIDTH : DRAWER_WIDTH_COLLAPSED}px; }`}</style>
      <StyledAppDrawer variant="permanent" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
        <Box paddingLeft={(theme) => theme.spacing(4.2)} paddingTop={(theme) => theme.spacing(10)}>
          <IconButton
            aria-hidden="true"
            tabIndex={-1}
            onClick={() => setOpen((prevState) => !prevState)}
            sx={{
              color: (theme) => theme.palette.common.white,
            }}
          >
            {open ? <KeyboardDoubleArrowLeft /> : <KeyboardDoubleArrowRight />}
          </IconButton>
        </Box>

        <StyledNavContainer component="nav">
          <StyledNavContainerInner pl={open ? 7 : 5}>
            <StyledSidebarMenuLink to={ESCRIPT_REFILL_ROUTE} onClick={scrollToTop} aria-label="Home">
              {open ? <Logo width="80px" height="19px" /> : <Icon width="29px" height="19px" fillColor="white" />}
            </StyledSidebarMenuLink>
          </StyledNavContainerInner>

          <StyledListContainer role="menubar">
            {mainMenuItems.map((mainMenuItem) => (
              <NavMenuItem
                key={mainMenuItem.id}
                toggleText={open}
                menuItem={mainMenuItem}
                onClick={scrollToTop}
                isSideBar
              />
            ))}

            <Logout toggleText={open} />
          </StyledListContainer>
        </StyledNavContainer>
      </StyledAppDrawer>
    </>
  );
}

export default Sidebar;
